/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1SerieSerieidLangs202,
  PostApiV1SerieSerieidLangs400,
  PostApiV1SerieSerieidLangs401,
  PostApiV1SerieSerieidLangs404,
  PostApiV1SerieSerieidLangs500,
  PostApiV1SerieSerieidLangsMutationRequest,
  PostApiV1SerieSerieidLangsMutationResponse,
  PostApiV1SerieSerieidLangsPathParams,
} from "../../types/serieIdiomasController/PostApiV1SerieSerieidLangs.ts";
import { createSerieLangRequestViewModelSchema } from "../createSerieLangRequestViewModelSchema.ts";
import { serieLangViewModelSchema } from "../serieLangViewModelSchema.ts";

export const postApiV1SerieSerieidLangsPathParamsSchema = z.object({
  serieId: z.coerce.number().int(),
}) as unknown as ToZod<PostApiV1SerieSerieidLangsPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1SerieSerieidLangs202Schema = z.lazy(
  () => serieLangViewModelSchema,
) as unknown as ToZod<PostApiV1SerieSerieidLangs202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1SerieSerieidLangs400Schema =
  z.any() as unknown as ToZod<PostApiV1SerieSerieidLangs400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1SerieSerieidLangs401Schema =
  z.any() as unknown as ToZod<PostApiV1SerieSerieidLangs401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1SerieSerieidLangs404Schema =
  z.any() as unknown as ToZod<PostApiV1SerieSerieidLangs404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1SerieSerieidLangs500Schema =
  z.any() as unknown as ToZod<PostApiV1SerieSerieidLangs500>;

export const postApiV1SerieSerieidLangsMutationRequestSchema = z.lazy(
  () => createSerieLangRequestViewModelSchema,
) as unknown as ToZod<PostApiV1SerieSerieidLangsMutationRequest>;

export const postApiV1SerieSerieidLangsMutationResponseSchema = z.lazy(
  () => postApiV1SerieSerieidLangs202Schema,
) as unknown as ToZod<PostApiV1SerieSerieidLangsMutationResponse>;
